import React from "react";
import { AHText, Box, BoxProps, TouchableBox } from "arkh";
import { TaskTypeIcon, TaskTypeIconSize } from "../../../../types/TaskTypeIcon";
import { TaskTypesType } from "../../../../types/TaskUIType";
import { Task } from "../../State/Routine/types";
import { FormattedMessage } from "react-intl";

export const TaskResponseCheckOptionTitle = () => (
  <AHText type="list-item-title" spaceTop="xsmall">
    <FormattedMessage
      defaultMessage="Check"
      description="TaskResponseTypeSelect title TaskCheck option"
    />
  </AHText>
);

export const TaskResponseNumberOptionTitle = () => (
  <AHText type="list-item-title" spaceTop="xsmall">
    <FormattedMessage
      defaultMessage="Number"
      description="TaskResponseTypeSelect title TaskNumber option"
    />
  </AHText>
);

export const TaskResponseTextOptionTitle = () => (
  <AHText type="list-item-title" spaceTop="xsmall">
    <FormattedMessage
      defaultMessage="Text"
      description="TaskResponseTypeSelect title TaskText option"
    />
  </AHText>
);

const TaskResponseCheckOption = (props: { onPress(): void }) => (
  <Box style={{ alignItems: "center" }}>
    <TaskResponseTypeSelectOption onPress={props.onPress} type="TaskCheck" />
    <TaskResponseCheckOptionTitle />
  </Box>
);

const TaskResponseNumberOption = (props: { onPress(): void }) => (
  <Box style={{ alignItems: "center" }}>
    <TaskResponseTypeSelectOption onPress={props.onPress} type="TaskNumber" />
    <TaskResponseNumberOptionTitle />
  </Box>
);

const TaskResponseTextOption = (props: { onPress(): void }) => (
  <Box style={{ alignItems: "center" }}>
    <TaskResponseTypeSelectOption onPress={props.onPress} type="TaskText" />
    <TaskResponseTextOptionTitle />
  </Box>
);

export const TaskResponseTypeSelect = (props: {
  onPress: (type: TaskTypesType) => void;
}) => (
  <Box style={{ flexDirection: "row", justifyContent: "space-around" }}>
    <TaskResponseCheckOption onPress={() => props.onPress("TaskCheck")} />
    <Box spaceLeft="large" />
    <TaskResponseNumberOption onPress={() => props.onPress("TaskNumber")} />
    <Box spaceLeft="large" />
    <TaskResponseTextOption onPress={() => props.onPress("TaskText")} />
  </Box>
);

const TaskResponseTypeSelectOption = ({
  type,
  onPress,
  ...boxProps
}: {
  type: Task["type"];
  onPress: (type: TaskTypesType) => void;
} & BoxProps) => (
  <TouchableBox {...boxProps} onPress={() => onPress(type)}>
    <TaskTypeIcon type={{ __typename: type }} size={TaskTypeIconSize.BIG} />
  </TouchableBox>
);
